/* eslint-disable react-hooks/exhaustive-deps */
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { Switch, Button, Tag } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import CourseInfo from "./CourseInfo";
import CourseSection from "./CourseSection";
import CreateEditCourseSectionModal from "./CreateEditSectionModal";
import HintFeedbackModal from "./HintFeedbackModal";
import {
  showErrorNotification,
  showSuccessNotification,
  showWarningNotification
} from "../../utils/notification";
import { clamp } from "../../utils/responsiveHelpers";

const CourseManagementDash = ({ ROOT_URL }) => {
  const [query] = useSearchParams();
  const [courseId, setCourseId] = useState("");
  const [courseData, setCourseData] = useState({});
  const [sectionsData, setSectionsData] = useState([]);
  const [isSectionCreateEditModalOpen, setIsSectionCreateEditModalOpen] = useState(false);
  const [educatorsList, setEducatorsList] = useState([]);
  const [showHidden, setShowHidden] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [currentSectionId, setCurrentSectionId] = useState("");
  const [hintFeedbackModalOpen, setHintFeedbackModalOpen] = useState(false);

  const fetchCourseEducators = () => {
    axios
      .get(`${ROOT_URL}/admin/course-educator/names-list`, {})
      .then((res) => {
        const { courseEducatorNames } = res.data;
        setEducatorsList(courseEducatorNames);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };
  const fetchCourseDetails = (id) => {
    axios
      .get(`${ROOT_URL}/admin/courses/manage/course-data`, {
        params: {
          courseId: id,
          showHidden: showHidden
        }
      })
      .then((res) => {
        const { courseDetails, sectionWithResources } = res.data;
        setCourseData(courseDetails);
        setSectionsData(sectionWithResources);
        showSuccessNotification("Course Data Fetched Successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleSectionCreateEdit = (sectionParams) => {
    if (isEdit) {
      axios
        .post(`${ROOT_URL}/admin/courses/manage/section/edit`, {
          sectionParams,
          currentSectionId
        })
        .then(() => {
          setCurrentSectionId("");
          setIsEdit(false);
          setInitialValues({});
          fetchCourseDetails(courseId);
          showSuccessNotification("Section updated Successfully");
          setIsSectionCreateEditModalOpen(false);
        })
        .catch((err) => {
          const errorMessage = err?.response?.data;
          showErrorNotification(errorMessage);
        });
    } else {
      axios
        .post(`${ROOT_URL}/admin/courses/manage/section/create`, {
          sectionParams,
          courseId
        })
        .then(() => {
          fetchCourseDetails(courseId);
          showSuccessNotification("Section created Successfully");
          setIsSectionCreateEditModalOpen(false);
        })
        .catch((err) => {
          const errorMessage = err?.response?.data;
          showErrorNotification(errorMessage);
        });
    }
  };

  const handleSectionDelete = (sectionId) => {
    axios
      .post(`${ROOT_URL}/admin/courses/manage/section/delete`, {
        sectionId
      })
      .then(() => {
        fetchCourseDetails(courseId);
        showSuccessNotification("Section deleted Successfully");
      })
      .catch((err) => {
        const errorMessage = err?.response?.data;
        showErrorNotification(errorMessage);
      });
  };

  const handleSyncAllTasksWithProgress = () => {
    axios
      .post(`${ROOT_URL}/admin/courses/manage/sync-new-tasks`, {
        courseId
      })
      .then(() => {
        showSuccessNotification("Tasks synced successfully");
      })
      .catch((err) => {
        showWarningNotification(err);
      });
  };

  const handleShowHiddenToggle = () => {
    setShowHidden(!showHidden);
  };

  const handleHideSection = (sectionId, isHidden) => {
    axios
      .post(`${ROOT_URL}/admin/courses/manage/section/edit`, {
        sectionParams: { hidden: !isHidden },
        sectionId
      })
      .then(() => {
        setCurrentSectionId("");
        setIsEdit(false);
        setInitialValues({});
        fetchCourseDetails(courseId);
        showSuccessNotification("Section updated Successfully");
        setIsSectionCreateEditModalOpen(false);
      })
      .catch((err) => {
        const errorMessage = err?.response?.data;
        showErrorNotification(errorMessage);
      });
  };

  useEffect(() => {
    const id = query.get("id");
    setCourseId(id);
    fetchCourseDetails(id);
    fetchCourseEducators();
  }, [courseId, showHidden]);

  return (
    <div
      style={{
        marginTop: "20px",
        marginLeft: clamp(12, 30),
        marginRight: clamp(12, 30)
      }}
    >
      Show hidden sections : <Switch checked={showHidden} onChange={handleShowHiddenToggle} />
      <Button
        style={{ margin: "0 10px" }}
        type="primary"
        onClick={() => {
          setHintFeedbackModalOpen(true);
        }}
      >
        Show Hint Feedback
      </Button>
      <CourseInfo courseDetails={courseData} />
      <br />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "10px"
        }}
      >
        <div>
          <Button
            type="primary"
            onClick={() => {
              setIsSectionCreateEditModalOpen(true);
            }}
          >
            Create Section
          </Button>
        </div>

        <div>
          <Button
            type="primary"
            danger
            onClick={() => {
              handleSyncAllTasksWithProgress();
            }}
          >
            Sync new tasks with User Progress
          </Button>
        </div>
      </div>
      {(sectionsData || []).map((sectionData) => (
        <div
          key={sectionData?.sectionId}
          style={{
            marginTop: "1em"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              flexWrap: "wrap"
            }}
          >
            <p>
              <b>{sectionData?.sectionDetails?.name}</b>, Display Order:{" "}
              {sectionData?.sectionDetails?.displayOrder}
              <Tag color="green" style={{ marginLeft: "5px" }}>
                {sectionData?.sectionDetails?.category || "NORMAL"}
              </Tag>
            </p>
            <Button
              type="primary"
              danger
              onClick={() => {
                handleSectionDelete(sectionData.sectionId);
              }}
            >
              Delete
            </Button>

            <Button
              type="primary"
              onClick={() => {
                setCurrentSectionId(sectionData?.sectionId);
                setIsEdit(true);
                const { description, displayOrder, name, category } =
                  sectionData?.sectionDetails || {};
                setInitialValues({ description, displayOrder, name, category });
                setIsSectionCreateEditModalOpen(true);
              }}
            >
              Edit
            </Button>
            <Button
              type="primary"
              onClick={() => {
                handleHideSection(sectionData?.sectionId, sectionData?.sectionDetails?.hidden);
              }}
            >
              {sectionData?.sectionDetails?.hidden ? <EyeOutlined /> : <EyeInvisibleOutlined />}{" "}
              {!sectionData?.sectionDetails?.hidden ? "Hide" : "Show"}
            </Button>
          </div>

          <p>{sectionData?.sectionDetails?.description}</p>
          <CourseSection
            sectionDetails={sectionData}
            courseId={courseId}
            ROOT_URL={ROOT_URL}
            educatorList={educatorsList}
          />
        </div>
      ))}
      {isSectionCreateEditModalOpen === true && (
        <CreateEditCourseSectionModal
          isModalOpen={isSectionCreateEditModalOpen}
          setIsModalOpen={setIsSectionCreateEditModalOpen}
          handleCreateEdit={handleSectionCreateEdit}
          initialValues={initialValues}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          setInitialValues={setInitialValues}
        />
      )}
      {hintFeedbackModalOpen && (
        <HintFeedbackModal
          isModalOpen={hintFeedbackModalOpen}
          setIsModalOpen={setHintFeedbackModalOpen}
          sectionsData={sectionsData}
          courseId={courseId}
          ROOT_URL={ROOT_URL}
        />
      )}
    </div>
  );
};

export default CourseManagementDash;
